import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_6: DocMigration = {
  maxSchemaVersion: "0.0.6",
  apply(json: any) {
    if (!json.tables) {
      json.tables = {
        settings: {},
        palettes: {},
      };
    }

    if (!json.settings) {
      json.settings = {};
    }

    if (json.elevations) {
      for (const id in json.elevations) {
        if (!json.elevations[id].settings) {
          json.elevations[id].settings = {};
        }
      }
    }

    // move palettes into tables object
    if (json.palettes) {
      json.tables.palettes = json.palettes;
    }

    return json;
  },
};

export default migration_0_0_6;
